<template>
  <div class="api">
    <div class="container pl-0">
      <div aria-label="breadcrumb">
        <ol class="breadcrumb pb-2">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'home', params: { lang: $route.params.lang }}">{{ $t('CC01-03-08') }}</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"><a class="disabled">{{ $t('CC11-01-05c', { site_name: site_info[$i18n.locale].name }) }}</a></li>
        </ol>
      </div>
    </div>
    <div id="scroll-to-div" class="container-fluid">
      <div id="stickyBlockStartPoint" />
      <!-- ========== Hero Section ========== -->
      <div class="position-relative bg-img-hero">
        <div class="container space-2 position-relative z-index-2">
          <div class="row justify-content-lg-between align-items-center">
            <div class="col-md-6 col-lg-6">
              <div class="mb-5">
                <span class="d-block small font-weight-bold text-cap mb-2">{{ $t('M01f-03') }}</span>
                <h2>{{ $t('M01f-04') }}</h2>
              </div>
            </div>
            <div class="col-md-6 d-md-inline-block">
              <figure class="w-100">
                <img class="img-fluid" :src="require(`@/assets/svg/illustrations/about-hero.svg`)" alt="Image Description">
              </figure>
            </div>
          </div>
        </div>
      </div>
      <!-- ========== About Us Section ========== -->
      <div class="container space-top-2 space-bottom-3">
        <div class="w-md-80 w-lg-80 text-center mx-md-auto">
          <div class="mb-5">
            <span class="d-block small font-weight-bold text-cap mb-2">{{ $t('M01f-06') }}</span>
            <h3>{{ $t('M01f-07') }}</h3>
          </div>
          <p v-for="(item, index) in aboutUs" :key="index">{{ $t(item.text) }}</p>
        </div>
      </div>
      <!-- ========== History Section ========== -->
      <div class="position-relative container history-container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-12">
            <div class="card">
              <div class="container space-2 space-lg-3 w-lg-75 w-sm-90 mx-auto">
                <div class="mb-5 text-center space-bottom-1">
                  <span class="d-block small font-weight-bold text-cap mb-2">{{ $t('M01f-09') }}</span>
                  <h3>{{ $t('M01f-10a') }}</h3>
                </div>
                <ul class="step pt-4"> <!-- Timeline -->
                  <li v-for="(timelineItem, index) in history" :key="index" class="step-item" data-aos="fade-up"> <!-- Timeline Item -->
                    <div class="step-content-wrapper">
                      <span class="step-icon step-icon-sm step-icon-soft-primary"><i class="far fa-calendar-alt" /></span>
                      <div class="step-content mb-5">
                        <div class="row align-items-md-center">
                          <div class="col-md-6"><h5>{{ $t(timelineItem.title) }}</h5></div>
                          <div class="col-md-6 text-md-right"><p>{{ $t(timelineItem.year) }}</p></div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ========== What We Do Section ========== -->
      <div class="container space-top-3 px-0">
        <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
          <span class="d-block small font-weight-bold text-cap mb-2">{{ $t('M01f-11') }}</span>
          <h3>{{ $t('M01f-12', { site_name: site_info[$i18n.locale].name }) }}</h3>
        </div>
        <div class="row"> <!-- Icon Blocks -->
          <div v-for="(item, itemIndex) in whatWeDo" :key="itemIndex" class="col-md-4 mb-5 mb-md-0">
            <!-- Icon Blocks -->
            <div class="text-center px-lg-3">
              <figure class="max-w-10rem mx-auto mb-4">
                <img class="img-fluid" :src="require(`@/assets/svg/icons/${item.icon}.svg`)" alt="SVG">
              </figure>
              <h4>{{ $t(item.title) }}</h4>
              <p>{{ $t(item.description) }}</p>
            </div>
            <!-- End Icon Blocks -->
          </div>
        </div>
      </div>
      <!-- ========== End What We Do Section ========== -->
      <div class="space-1" />
      <CtaPartner />
      <div id="stickyBlockEndPoint" />
    </div>
  </div>
</template>

<script>
import CtaPartner from '@/components/cta-partner'
import { mapGetters } from 'vuex'

const aboutUs = [
  { text: 'M01f-08a' },
  { text: 'M01f-08b' },
  { text: 'M01f-08c' }
]

const history = [
  { title: 'M01f-10b', year: 2015 },
  { title: 'M01f-10c', year: 2015 },
  { title: 'M01f-10d', year: 2016 },
  { title: 'M01f-10e', year: 2018 },
  { title: 'M01f-10f', year: 2018 },
  { title: 'M01f-10g', year: 2019 },
  { title: 'M01f-10h', year: 2019 },
  { title: 'M01f-10i', year: 2019 },
  { title: 'M01f-10j', year: 2020 },
  { title: 'M01f-10k', year: 2020 },
  { title: 'M01f-10l', year: 2020 }
]

const whatWeDo = [
  {
    title: 'M01f-14',
    description: 'M01f-15',
    icon: 'icon-27'
  },
  {
    title: 'M01f-17',
    description: 'M01f-18',
    icon: 'icon-7'
  },
  {
    title: 'M01f-20',
    description: 'M01f-21',
    icon: 'icon-25'
  }
]

export default {
  name: 'AboutUs',
  components: {
    CtaPartner
  },
  data() {
    return {
      aboutUs: aboutUs,
      history: history,
      whatWeDo: whatWeDo
    }
  },
  computed: {
    ...mapGetters([
      'site_info'
    ])
  }
}
</script>

<style lang="scss" scoped>
.history-container {
  border-radius: 5px;
  box-shadow: 0 4px 16px 0 rgba(0,0,0,0.12);
  .card {
    background-color: transparent;
    box-shadow: none;
  }
}
.card {
  box-shadow: none;
}
</style>
